import type { Enemy } from '../enemies';

// MIRROR boss-arena: sync the mirrored boss twin position + flicker each frame.
// Twin lives at horizontally-mirrored x (W - x), same y. Pure stateless transform —
// caller passes the active flag derived from wave.bossArena/wave.wave.
export function syncMirrorBoss(enemies: Enemy[], mirrorActive: boolean, W: number): void {
  for (const en of enemies) {
    if (en.kind !== 'boss' || !en.mirror) continue;
    en.mirror.visible = mirrorActive && en.alive;
    if (!en.mirror.visible) continue;
    en.mirror.x = W - en.x;
    en.mirror.y = en.y;
    const flicker = 0.7 + 0.3 * Math.sin(en.t * 14);
    en.mirror.alpha = en.hitFlashT > 0 ? 1 : en.body.alpha * flicker;
  }
}
